// Construye el path para navegar a un tab de la ficha de cliente según el rol.
// El portal del rol `administrador` vive en AdminClientePage (`/`) y navega por
// query (`/?tab=...&clienteId=...`); el ejecutivo usa la ruta dedicada
// `/admin/clientes/:id?tab=...`. Componentes compartidos (EdificiosPage,
// AscensoresPage) que se renderizan en ambos portales deben usar este helper
// en vez de hardcodear la ruta del ejecutivo — si no, el administrador termina
// navegando a una ruta que su userType no tiene registrada (página en blanco).
export const buildClienteTabPath = (isAdmin, clienteId, tab, extra = {}) => {
  const qs = new URLSearchParams();
  qs.set('tab', tab);
  if (isAdmin) qs.set('clienteId', String(clienteId));
  for (const [k, v] of Object.entries(extra)) {
    if (v !== undefined && v !== null && v !== '') qs.set(k, String(v));
  }
  const base = isAdmin ? '/' : `/admin/clientes/${clienteId}`;
  return `${base}?${qs.toString()}`;
};

export default buildClienteTabPath;
